import { render, staticRenderFns } from "./ContestForm.vue?vue&type=template&id=2d9055a6&scoped=true&lang=pug&"
import script from "./ContestForm.vue?vue&type=script&lang=ts&"
export * from "./ContestForm.vue?vue&type=script&lang=ts&"
import style0 from "./ContestForm.vue?vue&type=style&index=0&id=2d9055a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9055a6",
  null
  
)

export default component.exports